/* AppleFX interactive panel (v8).
   Renders the REAL AppleFX 1.2.5 panel markup (assets/afx-panel-data.js, generated from the panel source)
   inside a shadow root, so its CSS can't touch the theme and the theme's CSS can't touch it.
   Everything a visitor can poke works: the 7 tabs, preset rows, sliders, segmented controls, the Bezier
   handles, live previews, light/dark, the 7 colorways (Apple logo menu or the swatches under the panel), Apply.
   Lazy: the ~290 KB data file (≈45 KB over the wire) loads only when the panel is about to scroll into view. */
(function () {
  'use strict';
  if (window.__afxpBoot) return; window.__afxpBoot = 1;

  var TABS = ['Easing', 'Text', 'Transitions', 'Glass', 'Styles', 'Shakes', 'Expressions'];
  var CWS = [
    { id: 'blue', label: 'Blue', sw: 'linear-gradient(135deg,#3d9bff 0%,#0a6bdd 100%)' },
    { id: 'cosmic-orange', label: 'Cosmic Orange', sw: 'linear-gradient(145deg,#ff8a2e 0%,#a83c06 55%,#2b0e03 100%)' },
    { id: 'burgundy', label: 'Burgundy', sw: 'linear-gradient(145deg,#d63a68 0%,#8e1238 55%,#2b0413 100%)' },
    { id: 'moonlight', label: 'Moonlight', sw: 'linear-gradient(145deg,#b7c8e8 0%,#52658c 55%,#0d1322 100%)' },
    { id: 'sage', label: 'Sage', sw: 'linear-gradient(145deg,#58a874 0%,#285c3a 55%,#0a1810 100%)' },
    { id: 'lavender', label: 'Lavender', sw: 'linear-gradient(145deg,#a888f2 0%,#5636b0 55%,#120a26 100%)' },
    { id: 'gold', label: 'Gold', sw: 'linear-gradient(145deg,#dfb45e 0%,#7c5518 55%,#160e04 100%)' }
  ];
  /* easing presets (from src/presets/easing.ts; springs drawn as their closest Bezier) */
  var EASE = {
    'Apple Standard': [0.4, 0, 0.2, 1], 'Emphasized': [0.2, 0, 0, 1], 'Decelerated': [0, 0, 0.2, 1],
    'Accelerated': [0.4, 0, 1, 1], 'Spring · Soft': [0.25, 1.18, 0.5, 1, 'spring(freq 3, damping 18)'],
    'Spring · Bouncy': [0.3, 1.55, 0.45, 1, 'spring(freq 3, damping 8)'], 'Snap': [0.16, 1.4, 0.3, 1],
    'Anticipate': [0.6, -0.3, 0.4, 1], 'Bouncy': [0.34, 1.56, 0.64, 1]
  };
  var MOON = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>';
  var SUN = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"></circle><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"></path></svg>';
  var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  var EXTRA =
    ':host{display:block;position:relative;contain:layout paint}' +
    '.afxp-scale{position:absolute;left:0;top:0;transform-origin:0 0}' +
    '.afxp{position:relative;overflow:hidden;border-radius:14px;-webkit-font-smoothing:antialiased}' +
    '.afxp ::-webkit-scrollbar{width:6px;height:6px}.afxp ::-webkit-scrollbar-thumb{background:rgb(var(--label)/.18);border-radius:6px}' +
    '.afxp button:focus-visible,.afxp [role=button]:focus-visible{outline:2px solid rgb(var(--accent));outline-offset:2px}' +
    '.afxp input[type=text]{pointer-events:none}' +
    '.afxp-toast{position:absolute;left:50%;bottom:44px;z-index:80;transform:translate(-50%,14px) scale(.96);opacity:0;pointer-events:none;' +
      'display:flex;align-items:center;gap:8px;padding:9px 16px;border-radius:999px;font:600 12px/1.2 -apple-system,BlinkMacSystemFont,"SF Pro Text",sans-serif;' +
      'color:#fff;background:rgb(var(--accent));box-shadow:0 10px 30px -8px rgb(var(--accent)/.7),inset 0 1px 0 rgba(255,255,255,.25);transition:opacity .25s,transform .45s cubic-bezier(.34,1.56,.64,1)}' +
    '.afxp-toast.on{opacity:1;transform:translate(-50%,0) scale(1)}' +
    '.afxp-toast svg{width:14px;height:14px}' +
    '.afxp-pop{position:absolute;left:10px;top:50px;z-index:90;width:236px;padding:12px;border-radius:14px;opacity:0;transform:translateY(-6px) scale(.97);transform-origin:20px 0;pointer-events:none;' +
      'background:rgb(var(--elevated));border:1px solid rgb(var(--hairline)/.3);box-shadow:0 24px 60px -18px rgba(0,0,0,.55);transition:opacity .2s,transform .3s cubic-bezier(.34,1.4,.64,1);' +
      'font:500 11px/1.3 -apple-system,BlinkMacSystemFont,"SF Pro Text",sans-serif;color:rgb(var(--label))}' +
    '.afxp.afx-cw .afxp-pop{background:rgb(0 0 0/.55);-webkit-backdrop-filter:blur(24px) saturate(1.4);backdrop-filter:blur(24px) saturate(1.4)}' +
    '.afxp-pop.on{opacity:1;transform:none;pointer-events:auto}' +
    '.afxp-pop b{display:block;font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:rgb(var(--label-tertiary));margin-bottom:10px}' +
    '.afxp-pop-row{display:flex;gap:7px;flex-wrap:wrap}' +
    '.afxp-sw{width:24px;height:24px;border-radius:50%;border:0;cursor:pointer;padding:0;box-shadow:inset 0 0 0 1px rgba(255,255,255,.18),0 2px 6px rgba(0,0,0,.3);transition:transform .2s}' +
    '.afxp-sw:hover{transform:scale(1.12)}.afxp-sw.on{box-shadow:0 0 0 2px rgb(var(--surface)),0 0 0 4px rgb(var(--accent))}' +
    '.afxp-pop i{display:block;font-style:normal;margin-top:10px;color:rgb(var(--label-secondary))}' +
    '.afxp-pressed{animation:afxpPress .5s cubic-bezier(.34,1.56,.64,1)}@keyframes afxpPress{30%{transform:scale(.9)}}' +
    '.afxp-ch{display:inline-block;white-space:pre}';

  function fmt(v, step) { var d = (String(step).split('.')[1] || '').length; return (+v).toFixed(d); }
  function cls(el, from, to) { el.className = el.className.replace(from, to); }
  function txt(el) { return (el && el.textContent || '').trim(); }

  function Panel(host, D) {
    var self = this;
    this.host = host; this.D = D; this.tab = 'text'; this.cw = 'blue'; this.dark = true; this.vis = true;
    this.root = host.attachShadow ? host.attachShadow({ mode: 'open' }) : null;
    if (!this.root) return;
    this.root.innerHTML = '<style>' + D.css + EXTRA + '</style><style id="cwcss"></style>' +
      '<div class="afxp-scale"><div class="afxp dark" id="wrap"><div class="afxp-body"><div id="root"></div></div>' +
      '<div class="afxp-toast" id="toast"></div><div class="afxp-pop" id="pop"></div></div></div>';
    this.wrap = this.root.getElementById('wrap');
    this.rootEl = this.root.getElementById('root');
    this.scaleEl = this.root.querySelector('.afxp-scale');
    this.cwStyle = this.root.getElementById('cwcss');
    this.toastEl = this.root.getElementById('toast');
    this.pop = this.root.getElementById('pop');
    this.buildPop();
    this.fit();
    this.render(host.getAttribute('data-tab') || 'text');
    this.root.addEventListener('click', function (e) { self.onClick(e); });
    this.root.addEventListener('input', function (e) { if (e.target.type === 'range') self.onRange(e.target); });
    this.root.addEventListener('pointerdown', function (e) { self.onDown(e); });
    var ro = window.ResizeObserver ? new ResizeObserver(function () { self.fit(); }) : null;
    if (ro) ro.observe(host.parentNode || host); else window.addEventListener('resize', function () { self.fit(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { self.vis = es[es.length - 1].isIntersecting; if (self.vis) self.kick(); }).observe(host);
    host.afxp = this;
    host.dispatchEvent(new CustomEvent('afxp:ready', { bubbles: true }));
  }

  Panel.prototype.fit = function () {
    var w = (this.host.parentNode || this.host).clientWidth || this.host.clientWidth || 1100;
    var mobile = w < 700;
    var W = mobile ? 420 : 1100, H = mobile ? 720 : 700;
    if (W !== this.W) { this.W = W; this.H = H; this.mobile = mobile; this.wrap.style.width = W + 'px'; this.wrap.style.height = H + 'px'; if (this.tab) this.render(this.tab); }
    var s = Math.min(1, w / W);
    this.scaleEl.style.transform = 'scale(' + s + ')';
    this.host.style.height = Math.round(H * s) + 'px';
  };

  /* ---------- rendering ---------- */
  Panel.prototype.render = function (tab) {
    var html = this.D.tabs[tab]; if (!html) return;
    this.stop();
    this.tab = tab;
    this.rootEl.innerHTML = html;
    var r = this.rootEl;
    if (this.mobile) { var sb = r.querySelector('aside'); sb = sb && sb.closest('[style*="width: 240px"]'); if (sb) sb.style.width = '166px'; }
    this.syncThemeBtn();
    this.sec = r.querySelector('section');
    this.status = this.sec && this.sec.querySelector('.border-t .truncate, .border-t > div:first-child');
    this.statusText = txt(this.status);
    if (tab === 'easing') this.easeInit();
    this.kick(true);
  };

  Panel.prototype.syncThemeBtn = function () {
    var b = this.rootEl.querySelector('[aria-label="Toggle theme"]'); if (!b) return;
    var themed = this.cw !== 'blue';
    b.setAttribute('aria-disabled', themed ? 'true' : 'false');
    b.style.opacity = themed ? '.45' : '';
    var sp = b.querySelector('.afx-theme-spin'); if (sp) sp.innerHTML = this.dark ? SUN : MOON;
  };

  /* ---------- clicks ---------- */
  Panel.prototype.onClick = function (e) {
    var t = e.target.closest('button,[role=button]');
    if (!this.pop.contains(e.target) && !(t && t.getAttribute('aria-label') === 'Settings')) this.pop.classList.remove('on');
    if (!t) return;
    var al = t.getAttribute('aria-label') || '';
    if (TABS.indexOf(al) > -1) { this.render(al.toLowerCase()); this.emit('tab'); return; }
    if (al === 'Toggle theme') { if (this.cw === 'blue') { this.dark = !this.dark; this.wrap.classList.toggle('dark', this.dark); this.syncThemeBtn(); this.emit('theme'); } return; }
    if (al === 'Settings') { this.pop.classList.toggle('on'); return; }
    if (/favorites/.test(al)) { e.stopPropagation(); var on = t.getAttribute('data-fav') !== '1'; t.setAttribute('data-fav', on ? '1' : '0'); var p = t.querySelector('path'); if (p) p.setAttribute('fill', on ? 'currentColor' : 'none'); t.style.color = on ? '#ffd60a' : ''; return; }
    if (t.classList.contains('afxp-sw')) { this.setCw(t.getAttribute('data-cw')); return; }
    if (t.getAttribute('role') === 'button' && t.closest('aside')) { this.select(t); return; }
    if (t.classList.contains('afx-action')) { this.apply(t); return; }
    if (/^Replay/.test(txt(t))) { this.kick(true); return; }
    if (/^Copy$/.test(txt(t))) { t.textContent = 'Copied'; setTimeout(function () { t.textContent = 'Copy'; }, 1400); return; }
    this.segment(t);
  };

  /* segmented controls: In/Out, Auto/Position/... — swap the "on" class string with the active sibling */
  Panel.prototype.segment = function (b) {
    var par = b.parentNode; if (!par) return;
    var sibs = [].filter.call(par.children, function (x) { return x.tagName === 'BUTTON'; });
    if (sibs.length < 2) return;
    var act = sibs.filter(function (x) { return /\bbg-accent\b|\bafx-seg-on\b/.test(x.className); })[0];
    if (!act || act === b) return;
    var a = act.className; act.className = b.className; b.className = a;
    this.kick(true);
  };

  Panel.prototype.select = function (row) {
    var list = row.closest('.overflow-y-auto'); if (!list) return;
    var cur = list.querySelector('[role=button].text-white');
    if (cur === row) { this.kick(true); return; }
    if (cur) {
      cls(cur, 'text-white', 'text-label hover:translate-x-[2px] hover:bg-surface/60');
      var cd = cur.querySelector('.rounded-full'); if (cd) cls(cd, 'bg-white', 'bg-accent/60 group-hover:bg-accent');
      var cs = cur.querySelector('.text-white\\/75'); if (cs) cls(cs, 'text-white/75', 'text-label-secondary');
      var cb = cur.querySelector('button'); if (cb && !/data-fav="1"/.test(cb.outerHTML)) cls(cb, 'text-label-tertiary hover:text-label', 'text-transparent group-hover:text-label-tertiary hover:text-label');
    }
    cls(row, 'text-label hover:translate-x-[2px] hover:bg-surface/60', 'text-white');
    var d = row.querySelector('.rounded-full'); if (d) cls(d, 'bg-accent/60 group-hover:bg-accent', 'bg-white');
    var s = row.querySelector('.text-label-secondary'); if (s) cls(s, 'text-label-secondary', 'text-white/75');
    var b = row.querySelector('button'); if (b) cls(b, 'text-transparent group-hover:text-label-tertiary hover:text-label', 'text-label-tertiary hover:text-label');
    var hl = list.querySelector('[aria-hidden="true"].absolute');
    if (hl) { hl.style.top = row.offsetTop + 'px'; hl.style.height = row.offsetHeight + 'px'; }
    var name = txt(row.querySelector('.text-\\[13px\\]')) || txt(row);
    var sub = txt(row.querySelector('.text-\\[11px\\]'));
    this.preset = name;
    var h2 = this.sec && this.sec.querySelector('h2'); if (h2) h2.textContent = name;
    if (this.tab === 'easing') this.easeSet(EASE[name] || [0.4, 0, 0.2, 1]);
    if (this.tab === 'expressions') this.exprCode(name, sub);
    if (this.tab === 'styles') { var lab = this.sec.querySelector('.afx-stage-style span'); if (lab) lab.textContent = name; }
    if (this.tab === 'shakes') { var sl = this.sec.querySelector('.h-20.w-32 span'); if (sl) sl.textContent = name.split(' ')[0]; }
    this.kick(true);
  };

  /* ---------- sliders ---------- */
  Panel.prototype.onRange = function (el) {
    var min = +el.min, max = +el.max, v = +el.value, p = ((v - min) / (max - min) * 100).toFixed(1);
    el.style.background = 'linear-gradient(to right, rgb(var(--accent)) 0%, rgb(var(--accent)) ' + p + '%, rgb(var(--label, 60 60 67) / 0.18) ' + p + '%, rgb(var(--label, 60 60 67) / 0.18) 100%)';
    var box = el.parentNode, ti = box && box.querySelector('input[type=text]');
    if (ti) ti.value = fmt(v, el.step || 1);
    this.param();
  };
  Panel.prototype.val = function (label, def) {
    var spans = this.sec ? this.sec.querySelectorAll('span.text-label-secondary') : [];
    for (var i = 0; i < spans.length; i++) if (txt(spans[i]) === label) {
      var box = spans[i].closest('div').parentNode, r = box && box.querySelector('input[type=range]');
      if (r) return +r.value;
    }
    return def;
  };
  Panel.prototype.seg = function () { var b = this.sec && this.sec.querySelector('.flex.gap-1 > button.bg-accent'); return b ? txt(b).toLowerCase() : 'in'; };

  /* param change: update the live preview without a full replay where it can follow live */
  Panel.prototype.param = function () {
    var t = this.tab;
    if (t === 'glass') return this.glass();
    if (t === 'styles') return this.style();
    if (t === 'text' || t === 'transitions') { clearTimeout(this.pt); var self = this; this.pt = setTimeout(function () { self.kick(true); }, 160); }
  };

  /* ---------- previews ---------- */
  Panel.prototype.stop = function () { clearTimeout(this.loopT); cancelAnimationFrame(this.raf); this.raf = 0; if (this.anim) { try { this.anim.forEach(function (a) { a.cancel(); }); } catch (e) {} this.anim = null; } };
  Panel.prototype.kick = function (force) {
    if (!this.sec || REDUCED && !force) return;
    if (!force && (this.raf || this.loopT)) return;
    this.stop();
    var t = this.tab;
    if (t === 'text') this.textAnim();
    else if (t === 'transitions') this.transAnim();
    else if (t === 'shakes') this.shake();
    else if (t === 'expressions') this.expr();
    else if (t === 'glass') this.glass();
    else if (t === 'styles') this.style();
  };
  Panel.prototype.loop = function (ms) { var self = this; clearTimeout(this.loopT); this.loopT = setTimeout(function () { self.loopT = 0; if (self.vis && !REDUCED) self.kick(true); else self.loopT = 0; }, ms); };

  Panel.prototype.textAnim = function () {
    var el = this.sec.querySelector('.text-4xl'); if (!el || !el.animate) return;
    var name = (this.preset || 'Hero Reveal').toLowerCase();
    var dur = (this.val('Duration', 0.8)) * 1000, blur = this.val('Blur', 12), sc = this.val('Scale start', 60) / 100;
    var out = this.seg() === 'out';
    var word = 'AppleFX', self0 = this;
    /* ambient loops + the two text-rewriting presets */
    var amb = { drift: [{ transform: 'translateX(-10px)' }, { transform: 'translateX(10px)' }], hover: [{ transform: 'translateY(-6px)' }, { transform: 'translateY(6px)' }],
      breathe: [{ transform: 'scale(.97)' }, { transform: 'scale(1.04)' }], sway: [{ transform: 'rotate(-4deg)' }, { transform: 'rotate(4deg)' }] };
    if (amb[name]) { el.textContent = word; this.anim = [el.animate(amb[name], { duration: 1600, iterations: Infinity, direction: 'alternate', easing: 'ease-in-out' })]; return; }
    if (name === 'wave' || name === 'wiggle letters') {
      el.innerHTML = word.split('').map(function (c) { return '<span class="afxp-ch">' + c + '</span>'; }).join('');
      this.anim = [].map.call(el.children, function (x, i) {
        return x.animate(name === 'wave' ? [{ transform: 'translateY(4px)' }, { transform: 'translateY(-8px)' }] : [{ transform: 'rotate(-8deg)' }, { transform: 'rotate(8deg)' }],
          { duration: name === 'wave' ? 700 : 260, delay: i * (name === 'wave' ? 90 : 37), iterations: Infinity, direction: 'alternate', easing: 'ease-in-out' });
      });
      return;
    }
    if (name === 'number counter' || name === 'scramble') {
      el.textContent = word; var t0 = performance.now(), CH = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&';
      var tick = function (now) {
        var p = Math.min(1, (now - t0) / dur);
        if (name === 'number counter') { var e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(2400 * e).toLocaleString('en-US'); }
        else el.textContent = word.split('').map(function (c, i) { return p * word.length > i + 0.5 ? c : CH[Math.random() * CH.length | 0]; }).join('');
        if (p < 1) self0.raf = requestAnimationFrame(tick); else { self0.raf = 0; self0.loop(1600); }
      };
      this.raf = requestAnimationFrame(tick); return;
    }
    var perChar = /letter|burst|typewriter|cascade|iris|wave|bounce up|bounce rotate|stagger/.test(name) && !/word/.test(name);
    var fr, ease = 'cubic-bezier(0.22, 1, 0.36, 1)';
    if (/typewriter/.test(name)) fr = [{ opacity: 0 }, { opacity: 0, offset: 0.001 }, { opacity: 1, offset: 0.002 }, { opacity: 1 }];
    else if (/bounce|pop|spring/.test(name)) { fr = [{ opacity: 0, transform: 'scale(' + sc + ')' + (/rotate/.test(name) ? ' rotate(-24deg)' : '') + (/up/.test(name) ? ' translateY(60%)' : '') }, { opacity: 1, transform: 'none' }]; ease = 'cubic-bezier(0.34, 1.56, 0.64, 1)'; }
    else if (/slide up|rise|fade up/.test(name)) fr = [{ opacity: 0, transform: 'translateY(55%)', filter: 'blur(' + blur / 2 + 'px)' }, { opacity: 1, transform: 'none', filter: 'blur(0)' }];
    else if (/slide/.test(name)) fr = [{ opacity: 0, transform: 'translateX(-40%)' }, { opacity: 1, transform: 'none' }];
    else if (/skew/.test(name)) fr = [{ opacity: 0, transform: 'translateX(-30%) skewX(-24deg)', color: 'rgb(var(--accent))' }, { opacity: 1, transform: 'none' }];
    else if (/color/.test(name)) fr = [{ opacity: 0, transform: 'scale(' + sc + ')', filter: 'blur(' + blur + 'px)', color: 'rgb(var(--accent))' }, { opacity: 1, transform: 'none', filter: 'blur(0)' }];
    else if (/iris|scale down/.test(name)) fr = [{ opacity: 0, transform: 'scale(1.6)', filter: 'blur(' + blur + 'px)' }, { opacity: 1, transform: 'none', filter: 'blur(0)' }];
    else if (/glow/.test(name)) fr = [{ opacity: 0, textShadow: '0 0 24px rgb(var(--accent))' }, { opacity: 1, textShadow: '0 0 0 transparent' }];
    else if (/rotate|spin/.test(name)) fr = [{ opacity: 0, transform: 'rotate(-90deg) scale(' + sc + ')' }, { opacity: 1, transform: 'none' }];
    else fr = [{ opacity: 0, transform: 'scale(' + sc + ')', filter: 'blur(' + blur + 'px)' }, { opacity: 1, transform: 'none', filter: 'blur(0)' }];
    if (out) fr = fr.slice().reverse();
    var targets;
    if (perChar) {
      el.innerHTML = word.split('').map(function (c) { return '<span class="afxp-ch">' + c + '</span>'; }).join('');
      targets = [].slice.call(el.children);
    } else { el.textContent = word; targets = [el]; }
    var step = perChar ? Math.min(90, dur / 6) : 0, self = this;
    this.anim = targets.map(function (x, i) {
      return x.animate(fr, { duration: /typewriter/.test(name) ? step * 2 : dur, delay: (out ? targets.length - 1 - i : i) * step, easing: ease, fill: 'both' });
    });
    this.loop(dur + step * targets.length + (out ? 700 : 1500));
  };

  Panel.prototype.transAnim = function () {
    var stage = this.sec.querySelector('[style*="animation"]'); if (!stage) return;
    var name = (this.preset || 'Pop In').toLowerCase().replace(/[^a-z]+/g, '-').replace(/^-|-$/g, '');
    var alias = { zoom: 'pop-in', 'whip-pan': 'blur-in', blur: 'blur-in', rise: 'bounce-in', drop: 'drop-in', pop: 'pop-in', slide: 'blur-in', fade: 'blur-in', carousel: 'spin-in' };
    var kf = 'applefx-trans-' + (alias[name] || name);
    if (this.D.css.indexOf('@keyframes ' + kf) < 0) kf = 'applefx-trans-pop-in';
    var d = this.val('Duration', 2);
    stage.style.animation = 'none'; void stage.offsetWidth;
    stage.style.animation = d + 's cubic-bezier(0.4, 0, 0.2, 1) infinite both ' + kf;
  };

  Panel.prototype.shake = function () {
    var el = this.sec.querySelector('.h-20.w-32'); if (!el) return;
    var self = this, t0 = performance.now(), seed = Math.random() * 100;
    function n(x) { return Math.sin(x * 1.7 + seed) * 0.6 + Math.sin(x * 3.1 + seed * 2) * 0.3 + Math.sin(x * 5.3) * 0.1; }
    function f(now) {
      if (!self.vis) { self.raf = 0; return; }
      var I = self.val('Intensity', 55), R = self.val('Rotation', 4), F = self.val('Frequency', 12), S = self.val('Settle', 0.6);
      var t = ((now - t0) / 1000) % 2.2, env = t < 1.4 ? Math.pow(1 - t / 1.4, 1 + S * 2) : 0, k = I / 300 * 26;
      var x = n(t * F) * k * env, y = n(t * F + 40) * k * env * 0.7, r = n(t * F + 80) * R * env;
      el.style.transform = 'translate(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px) rotate(' + r.toFixed(2) + 'deg)';
      self.raf = requestAnimationFrame(f);
    }
    this.raf = requestAnimationFrame(f);
  };

  Panel.prototype.glass = function () {
    var card = this.sec.querySelector('.afx-stage-glass > div[style*="aspect-ratio"]'); if (!card) return;
    var w = this.val('Width', 792), h = this.val('Height', 388), r = Math.min(this.val('Corner Radius', 150), Math.min(w, h) / 2);
    var st = this.val('Glass Strength', 50), fb = this.val('Frost Blur', 28), gl = this.val('Glow', 0);
    card.style.width = 'min(' + w + 'px, 360px, 100% - 24px)';
    card.style.aspectRatio = w + ' / ' + h;
    card.style.borderRadius = (r / w * 100).toFixed(2) + '% / ' + (r / h * 100).toFixed(2) + '%';
    card.style.backgroundColor = 'rgba(255,255,255,' + (0.04 + st / 100 * 0.2).toFixed(3) + ')';
    card.style.backdropFilter = card.style.webkitBackdropFilter = 'blur(' + fb + 'px) saturate(160%)';
    card.style.boxShadow = '0 10px 32px rgba(0,0,0,.18)' + (gl ? ', 0 0 ' + (gl / 2) + 'px rgba(255,255,255,' + Math.min(0.6, gl / 100) + ')' : '');
    var lab = card.querySelector('.mt-1'); if (lab) lab.textContent = Math.round(w) + ' × ' + Math.round(h);
  };

  Panel.prototype.style = function () {
    var c = this.sec.querySelector('.afx-stage-style > div'); if (!c) return;
    var d = this.val('Distance', 12), s = this.val('Softness', 35), o = this.val('Opacity', 30);
    c.style.boxShadow = 'rgba(0,0,0,' + (o / 100).toFixed(2) + ') 0px ' + d + 'px ' + s + 'px';
  };

  Panel.prototype.exprCode = function (name, sub) {
    var code = this.sec.querySelector('pre code'); if (!code) return;
    var sig = this.sec.querySelector('h2 + div, .border-b .mt-2');
    if (name === 'Wiggle') return;
    if (sig) sig.textContent = sub || name;
    code.innerHTML = '<span class="text-syntax-comment">// AppleFX · ' + name + '\n// The full expression is applied to your property in one click.</span>';
  };

  Panel.prototype.expr = function () {
    var cv = this.sec.querySelector('canvas'); if (!cv || !cv.getContext) return;
    var self = this, ctx = cv.getContext('2d'), dpr = Math.min(2, window.devicePixelRatio || 1);
    var W = cv.clientWidth || 600, H = cv.clientHeight || 200; cv.width = W * dpr; cv.height = H * dpr; ctx.scale(dpr, dpr);
    var cs = getComputedStyle(this.wrap), acc = 'rgb(' + cs.getPropertyValue('--accent').trim().replace(/ /g, ',') + ')', lab = cs.getPropertyValue('--hairline').trim().replace(/ /g, ',');
    var trail = [], t0 = performance.now(), seed = Math.random() * 50;
    function n(x) { return Math.sin(x * 2.1 + seed) * 0.55 + Math.sin(x * 4.7 + seed * 1.3) * 0.3 + Math.sin(x * 9.2 + seed * 0.7) * 0.15; }
    function rr(x, y, s, r) { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + s, y, x + s, y + s, r); ctx.arcTo(x + s, y + s, x, y + s, r); ctx.arcTo(x, y + s, x, y, r); ctx.arcTo(x, y, x + s, y, r); ctx.closePath(); }
    function f(now) {
      if (!self.vis) { self.raf = 0; return; }
      var F = self.val('Frequency', 2), A = self.val('Amplitude', 30), O = self.val('Octaves', 1);
      var t = (now - t0) / 1000, k = A / 30 * 22, x = W / 2 + n(t * F * 0.5) * k * (1 + O * 0.15), y = H / 2 + n(t * F * 0.5 + 21) * k * 0.8;
      ctx.clearRect(0, 0, W, H);
      ctx.strokeStyle = 'rgba(' + lab + ',0.08)'; ctx.lineWidth = 1;
      for (var gx = 0; gx < W; gx += 20) { ctx.beginPath(); ctx.moveTo(gx + 0.5, 0); ctx.lineTo(gx + 0.5, H); ctx.stroke(); }
      for (var gy = 0; gy < H; gy += 20) { ctx.beginPath(); ctx.moveTo(0, gy + 0.5); ctx.lineTo(W, gy + 0.5); ctx.stroke(); }
      trail.push([x, y]); if (trail.length > 40) trail.shift();
      ctx.strokeStyle = acc; ctx.globalAlpha = 0.35; ctx.lineWidth = 1.5; ctx.beginPath();
      trail.forEach(function (p, i) { if (i) ctx.lineTo(p[0], p[1]); else ctx.moveTo(p[0], p[1]); }); ctx.stroke(); ctx.globalAlpha = 1;
      ctx.shadowColor = acc; ctx.shadowBlur = 18; ctx.fillStyle = acc; rr(x - 21, y - 21, 42, 11); ctx.fill(); ctx.shadowBlur = 0;
      var g = ctx.createLinearGradient(0, y - 21, 0, y + 21); g.addColorStop(0, 'rgba(255,255,255,.35)'); g.addColorStop(0.55, 'rgba(255,255,255,0)'); ctx.fillStyle = g; rr(x - 21, y - 21, 42, 11); ctx.fill();
      self.raf = requestAnimationFrame(f);
    }
    this.raf = requestAnimationFrame(f);
  };

  /* ---------- easing: draggable Bezier handles ---------- */
  Panel.prototype.easeInit = function () {
    var svg = this.sec && this.sec.querySelector('svg[viewBox="0 0 360 200"]'); this.svg = svg;
    if (!svg) return;
    var hit = svg.querySelectorAll('circle[r="18"]'), vis = svg.querySelectorAll('circle[r="5"]'), lines = svg.querySelectorAll('line[stroke-dasharray]');
    this.ez = { path: svg.querySelector('path'), hit: hit, vis: vis, lines: lines, code: this.sec.querySelector('.font-mono') };
    this.preset = 'Apple Standard';
  };
  Panel.prototype.easeSet = function (c) {
    var z = this.ez; if (!z) return;
    var X = function (v) { return 22 + v * 316; }, Y = function (v) { return 178 - v * 156; };
    var p1 = [X(c[0]), Y(c[1])], p2 = [X(c[2]), Y(c[3])];
    z.path.setAttribute('d', 'M 22 178 C ' + p1[0].toFixed(1) + ' ' + p1[1].toFixed(1) + ' ' + p2[0].toFixed(1) + ' ' + p2[1].toFixed(1) + ' 338 22');
    [p1, p2].forEach(function (p, i) {
      if (z.hit[i]) { z.hit[i].setAttribute('cx', p[0]); z.hit[i].setAttribute('cy', p[1]); }
      if (z.vis[i]) { z.vis[i].setAttribute('cx', p[0]); z.vis[i].setAttribute('cy', p[1]); }
      if (z.lines[i]) { z.lines[i].setAttribute('x2', p[0]); z.lines[i].setAttribute('y2', p[1]); }
    });
    var r = function (v) { return +(+v).toFixed(2); };
    if (z.code) z.code.textContent = c[4] || ('cubic-bezier(' + r(c[0]) + ', ' + r(c[1]) + ', ' + r(c[2]) + ', ' + r(c[3]) + ')');
    this.cur = c.slice(0, 4);
  };
  Panel.prototype.onDown = function (e) {
    var z = this.ez, c = e.target;
    if (!z || this.tab !== 'easing' || c.tagName !== 'circle' || c.getAttribute('r') !== '18') return;
    var i = c === z.hit[0] ? 0 : 1, svg = this.svg, self = this;
    if (!this.cur) this.cur = [0.4, 0, 0.2, 1];
    e.preventDefault(); c.style.cursor = 'grabbing';
    function mv(ev) {
      var pt = svg.createSVGPoint(); pt.x = ev.clientX; pt.y = ev.clientY;
      var q = pt.matrixTransform(svg.getScreenCTM().inverse());
      var x = Math.max(0, Math.min(1, (q.x - 22) / 316)), y = Math.max(-0.6, Math.min(1.6, (178 - q.y) / 156));
      var cc = self.cur.slice(); cc[i * 2] = x; cc[i * 2 + 1] = y; self.easeSet(cc);
    }
    function up() { c.style.cursor = 'grab'; window.removeEventListener('pointermove', mv); window.removeEventListener('pointerup', up); }
    window.addEventListener('pointermove', mv); window.addEventListener('pointerup', up);
  };

  /* ---------- apply / colorways ---------- */
  Panel.prototype.apply = function (btn) {
    btn.classList.remove('afxp-pressed'); void btn.offsetWidth; btn.classList.add('afxp-pressed');
    var label = txt(btn) || 'Apply', self = this;
    var msg = label === 'Insert' ? 'Inserted into your comp' : this.tab === 'easing' ? 'Ease applied to your keyframes' : 'Applied to 2 layers';
    this.toast(msg);
    if (this.status) { this.status.textContent = '✓ ' + msg; clearTimeout(this.st); this.st = setTimeout(function () { if (self.status) self.status.textContent = self.statusText; }, 2400); }
    this.kick(true);
    this.emit('apply');
  };
  Panel.prototype.toast = function (m) {
    var t = this.toastEl, self = this;
    t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' + m;
    t.classList.add('on'); clearTimeout(this.tt); this.tt = setTimeout(function () { t.classList.remove('on'); }, 1900);
  };
  Panel.prototype.buildPop = function () {
    var h = '<b>Accent</b><div class="afxp-pop-row">';
    CWS.forEach(function (c) { h += '<button type="button" class="afxp-sw' + (c.id === 'blue' ? ' on' : '') + '" data-cw="' + c.id + '" title="' + c.label + '" aria-label="' + c.label + '" style="background:' + c.sw + '"></button>'; });
    this.pop.innerHTML = h + '</div><i id="cwname">Blue</i>';
  };
  Panel.prototype.setCw = function (id) {
    if (!id) return;
    this.cw = id;
    this.cwStyle.textContent = id === 'blue' ? '' : (this.D.cw[id] || '');
    this.wrap.classList.toggle('afx-cw', id !== 'blue');
    this.wrap.classList.toggle('dark', id !== 'blue' ? true : this.dark);
    [].forEach.call(this.pop.querySelectorAll('.afxp-sw'), function (b) { b.classList.toggle('on', b.getAttribute('data-cw') === id); });
    var c = CWS.filter(function (x) { return x.id === id; })[0], nm = this.pop.querySelector('#cwname'); if (nm && c) nm.textContent = c.label;
    this.syncThemeBtn();
    if (this.tab === 'expressions') this.kick(true);
    this.emit('cw');
  };
  Panel.prototype.setDark = function (on) { if (this.cw !== 'blue') return; this.dark = !!on; this.wrap.classList.toggle('dark', this.dark); this.syncThemeBtn(); this.emit('theme'); };
  Panel.prototype.emit = function (what) { this.host.dispatchEvent(new CustomEvent('afxp:change', { bubbles: true, detail: { what: what, tab: this.tab, cw: this.cw, dark: this.dark } })); };

  /* ---------- boot ---------- */
  var loading = null;
  function load(src) {
    if (window.AFXP_DATA) return Promise.resolve(window.AFXP_DATA);
    if (loading) return loading;
    loading = new Promise(function (res, rej) {
      var s = document.createElement('script'); s.src = src; s.async = true;
      s.onload = function () { window.AFXP_DATA ? res(window.AFXP_DATA) : rej(); }; s.onerror = rej;
      document.head.appendChild(s);
    });
    return loading;
  }
  function init(host) {
    if (host.__afxp) return; host.__afxp = 1;
    load(host.getAttribute('data-src')).then(function (D) { new Panel(host, D); host.classList.add('is-live'); }).catch(function () { host.__afxp = 0; });
  }
  function scan() {
    var hosts = document.querySelectorAll('.afxp-host:not(.is-live)');
    [].forEach.call(hosts, function (h) {
      if (!('IntersectionObserver' in window)) return init(h);
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); init(h); } }, { rootMargin: '900px 0px' });
      io.observe(h);
    });
  }
  window.AFXP = { scan: scan, CWS: CWS };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
